<script>
  import ListHeader from '../../../../components/list/Header.vue'

  import * as restfulService from '../../../../services/restfulService'

  import bus from '@utils/bus'

  import {orderBy} from 'lodash'

  export default {
    components: {ListHeader},
    data () {
      return {
        activeTab: 'minicursos',
        mainEventId: null,
        list: [],
        filters: {
          subevento: '',
          orientador: ''
        }
      }
    },
    computed: {
      pageTitle: function () {
        return 'Minicursos'
      },
      listFiltered: function () {
        let list = this.list
        if (this.activeTab === 'minicursos') {
          return orderBy(list, ['start_datetime'], ['asc'])
        }
        return list
      }
    },
    mounted () {
      this.mainEventId = this.$route.params.id || null
      this.loadList(this.activeTab)
    },
    watch: {
      activeTab: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.loadList(newValue)
        }
      }
    },
    methods: {
      loadList (route) {
        bus.$emit('show-loader')
        this.list.splice(0)
        restfulService.get('event', 'reports/' + route, this.mainEventId)
          .then(response => {
            this.list = [...response]
            bus.$emit('hide-loader')
          })
          .catch((err) => {
            console.log(err)
            bus.$emit('hide-loader')
          })
      },
      calculaCor (inscritos, vagas) {
        let percentual = this.calculaPercentualInscritos(inscritos, vagas)
        if (percentual > 60) {
          return 'green'
        } else if (percentual > 30) {
          return 'orange'
        } else {
          return 'red'
        }
      },
      calculaPercentualInscritos (inscritos, vagas) {
        return Math.round((inscritos / vagas) * 100)
      }
    }
  }
</script>

<template>
    <div>
        <ListHeader :title="pageTitle" back-route="event.index"/>
        <el-tabs type="card" v-model="activeTab">
            <el-tab-pane name="minicursos" label="Listagem de Minicursos">
                <div class="responsive-table">
                    <table class="custom-table-list" v-if="activeTab === 'minicursos'">
                        <thead>
                        <tr>
                            <th colspan="11" style="font-size: 18px">Total: {{listFiltered.length}}</th>
                        </tr>
                        <tr>
                            <th>Cód. Minicurso</th>
                            <th>Minicurso</th>
                            <th>Data do Evento</th>
                            <th>Total Inscritos/Vagas</th>
                            <th class="btn-actions">Lista de Inscritos</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="item in listFiltered">
                            <td align="center">{{item.id}}</td>
                            <td>{{item.title}}</td>
                            <td>{{item.start_datetime | dateTimeEnToBr}}</td>
                            <td align="center">
                                {{item.modalities.length > 0 ? item.modalities[0].registrations.length : 0 }}/{{item.vacancies}}
                                <br>
                                <el-progress :percentage="calculaPercentualInscritos(item.modalities.length > 0 ? item.modalities[0].registrations.length : 0, item.vacancies)"
                                             :color="calculaCor(item.modalities.length > 0 ? item.modalities[0].registrations.length : 0 , item.vacancies)"
                                             :text-inside="true"
                                             :stroke-width="18">
                                </el-progress>
                            </td>
                            <td align="center">
                                <a :href="item.minicurso_pdf_path"
                                   target="_blank"
                                   class="el-button el-button--small"
                                   title="Lista de Inscritos">
                                    <i class="fa fa-file-pdf-o"></i>
                                </a>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>



// WEBPACK FOOTER //
// ReportsMinicursos.vue?2345f678